import React, { useEffect, useState } from "react";
import ReactHlsPlayer from 'react-hls-player';
import { useParams } from "react-router-dom"

export const Stream = () => {
    const { cam_name } = useParams()
    const [loading, setLoading] = useState(true);
    const [streamUrl, setStreamUrl] = useState('');

    useEffect(() => {
        if (cam_name) {
            let url = `https://h265api.glenwoodsouth.com/api/hls/${cam_name}/playlist.m3u8`
            setStreamUrl(url)
            setLoading(false)
        }
    }, [cam_name])
    
    return (
        loading ?
        <p>Loading...</p>
        :
        <ReactHlsPlayer
            src={streamUrl}
            autoPlay={true}
            muted={true}
            controls={false}
            width="100%"
            height="auto"
        />
    );
};
export default Stream;